/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DurationInputs */

const en_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const es_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const fr_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const de_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const ja_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所要時間/期間`)
};

const zh_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时长`)
};

const ar_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدة`)
};

const id_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durasi`)
};

const it_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const pt_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const ko_field_duration = /** @type {(inputs: Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기간/시간`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Field_DurationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_duration = /** @type {((inputs?: Field_DurationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DurationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_duration(inputs)
	if (locale === "es") return es_field_duration(inputs)
	if (locale === "fr") return fr_field_duration(inputs)
	if (locale === "de") return de_field_duration(inputs)
	if (locale === "ja") return ja_field_duration(inputs)
	if (locale === "zh") return zh_field_duration(inputs)
	if (locale === "ar") return ar_field_duration(inputs)
	if (locale === "id") return id_field_duration(inputs)
	if (locale === "it") return it_field_duration(inputs)
	if (locale === "ru") return ru_field_duration(inputs)
	if (locale === "pt") return pt_field_duration(inputs)
	return ko_field_duration(inputs)
});